// Override the mega-menu fade-out speed without editing theme.js
customElements.whenDefined('mega-menu-disclosure').then(() => {
  const MegaMenu = customElements.get('mega-menu-disclosure');

  const FADE_OUT_SECONDS = 0.1; // ← change this (theme default is 0.4)

  MegaMenu.prototype.createHideAnimationControls = function () {
    const el = this.contentElement;
    const anim = el.animate(
      { opacity: [1, 0] },
      { duration: FADE_OUT_SECONDS * 1000, easing: 'ease' }
    );
    // Commit the final state, matching the theme's behavior (inline opacity:0)
    anim.finished.then(() => { el.style.opacity = '0'; }).catch(() => {});
    return anim;
  };
});